import React, { useEffect, useMemo, useState } from "react";
import { APP_EMITTER_EVENTS, AppEmitter, FileInput, FormLabel } from "shared";
import { ITemplateFileComponent } from "entities/template";
import { IValidationFunc } from "../../../../lib/types/validation";
import { ComponentTooltip, IComponentTooltipSettings } from "../component_tooltip/component_tooltip";
import { useComponentsTranslations } from "../../../../lib/i18n";
import styles from "./document_form_file.module.scss";

interface IDocumentFormFileProps {
    component: ITemplateFileComponent;
    onChange: (tag: string, value?: File[]) => void;
    externalUpdateRecord: Record<string, any>;
    onValidationRegister: (validationFunc: IValidationFunc, tag: string) => void;
    label?: string;
    tooltip: IComponentTooltipSettings;
    triggerValidate: number;
}

export const DocumentFormFile: React.FC<IDocumentFormFileProps> = React.memo(({
                                                                                  component,
                                                                                  externalUpdateRecord,
                                                                                  label,
                                                                                  triggerValidate,
                                                                                  tooltip,
                                                                                  onValidationRegister,
                                                                                  onChange,
                                                                              }) => {
    const t = useComponentsTranslations();
    const [files, setFiles] = useState<File[]>([]);
    const [initialFiles, setInitialFiles] = useState<File[]>([]);

    const required = useMemo(() => {
        return component.required !== false;
    }, [component]);

    useEffect(() => {
        AppEmitter.on(APP_EMITTER_EVENTS.clearForm, handleClearEvent);
        return () => {
            AppEmitter.off(APP_EMITTER_EVENTS.clearForm, handleClearEvent);
        }
    }, [])

    useEffect(() => {
        return () => {
            onValidationRegister(() => {
                return Promise.resolve(true)
            }, component.name);
            onChange(component.name, undefined);
        }
    }, [])

    useEffect(() => {
        if (component.name) {
            onValidationRegister(validateComponent, component.name);
            onChange(component.name, files);
        }
    }, [component.name, files, required]);

    useEffect(() => {
        if (component.name) {
            setInitialFiles([]);
            setFiles([]);
        }
    }, [externalUpdateRecord, component.name])

    const handleClearEvent = () => {
        setInitialFiles([]);
        setFiles([]);
    }

    const validateComponent = (): Promise<boolean> => {
        const valid = !required || (Array.isArray(files) && files.length > 0);
        return Promise.resolve(valid);
    }

    return <div>
        <div className={styles.titleContainer}>
            <FormLabel title={label} required={required}/>
            <ComponentTooltip tooltip={tooltip} id={component.id.toString()} className={styles.tooltipContainer}/>
        </div>

        <div className={styles.fileContainer}>
            <FileInput
                buttonText={t("chooseFile")}
                multiple={false}
                initialFiles={initialFiles}
                // pdf прикладывается, но с косяками, поэтому не указываем,
                // можно приложить rtf или docx, в соответствии с форматом шаблона
                accept=".docx,.doc,.rtf,.xlsx,.xls,.png,.jpg,.jpeg"
                onFilesChange={setFiles}
                description={<div className={styles.fileInputDescription}>
                    <div className={styles.fileInputDescriptionLine}>{t("fileDescription")}</div>
                </div>}
                validate={required}
                triggerValidate={triggerValidate}
            />
        </div>

    </div>;
});
